export const AUTH_TOKEN = 'auth_token';
export const USER_KEY = 'user_info';
